import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { put } from '../utils/api';

const ThemeContext = createContext(null);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

const getSystemPreference = () => {
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return 'light';
};

export const ThemeProvider = ({ children }) => {
  // Dark mode disabled until fully polished - always use light
  const [preference, setPreference] = useState('light');
  const [resolved, setResolved] = useState('light');

  // Apply dark class to <html>
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('dark');
  }, []);

  const isDark = false;

  const setThemePreference = useCallback(async (pref) => {
    // Disabled - always light for now
  }, []);

  const initFromUser = useCallback((userTheme) => {
    // Disabled - always light for now
  }, []);

  const value = {
    isDark,
    preference,
    setThemePreference,
    initFromUser,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
